




































import {
  Vue,
  Component,
  Prop, Watch
} from "@/shared/vuepack";
import NoAccountMessage from "@/employee/components/NoAccountMessage.vue";
import ContributionPlannerWidget from "@/employee/components/widgets/ContributionPlannerWidget.vue";
import AccountBalanceWidget from "@/shared/widgets/AccountBalanceWidget.vue";
import ContributionsGraphWidget from "@/shared/components/contribution/ContributionsGraphWidget.vue";
import DeductibleTrackerWidget from "@/employee/components/widgets/DeductibleTrackerWidget.vue";
import DeductibleTrackerWidgetHPHC from "@/employee/components/widgets/DeductibleTrackerWidgetHPHC.vue";
import CashExpensesGraphWidget from "@/employee/components/widgets/CashExpensesGraphWidget.vue";
import TaxSavingsWidget from "@/employee/components/widgets/TaxSavingsWidget.vue";
import ExpenseCategoryWidget from "@/employee/components/widgets/ExpenseCategoryWidget.vue";
import {
  UserEventKey,
  UserEventType,
  HsabPlanType,
  CommunicationDashboard,
  FeatureFlags,
  StoreType
} from "@/shared/types";
import ExpenseEligibilityWidget from "@/employee/components/widgets/ExpenseEligibilityWidget.vue";
import HsaStoreWidget from "@/employee/components/widgets/HsaStoreWidget.vue";
import AmazonMarketplaceWidget from "@/employee/components/widgets/AmazonMarketplaceWidget.vue";
import AddMfa from "@/employee/components/onboarding/AddMfa.vue";
import WidgetGridContainer from "@/shared/components/ui/WidgetGridContainer.vue";
import * as RouteNames from "@/employee/route-names";
import {
  openUrl,
  getRoutePath
} from "@/shared/urlHelper";
import { useUserStore } from "@/shared/store/user";
import { useDeductibleTrackerStore } from "@/employee/store/deductibleTracker";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useHsaStore } from "@/shared/store/hsa";
import { useExpenseBalanceSummaryStore } from "@/employee/store/expenseBalanceSummary";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { usePartnerPortalStore } from "@/employee/store/partnerPortal";
import { useCommunicationStore } from "@/shared/store/communication";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useDevinirTransferInKindStore } from "@/employee/store/devinirTransferInKind";
import NoHsaStoreWidget from "@/employee/components/widgets/NoHsaStoreWidget.vue";

@Component({
  components: {
    HsaStoreWidget,
    NoAccountMessage,
    AccountBalanceWidget,
    ContributionsGraphWidget,
    CashExpensesGraphWidget,
    TaxSavingsWidget,
    ExpenseCategoryWidget,
    DeductibleTrackerWidget,
    DeductibleTrackerWidgetHPHC,
    ExpenseEligibilityWidget,
    ContributionPlannerWidget,
    AddMfa,
    WidgetGridContainer,
    AmazonMarketplaceWidget,
    NoHsaStoreWidget
  }
})
export default class Home extends Vue {
  userStore = useUserStore();
  deductibleTrackerStore = useDeductibleTrackerStore();
  portalCustomizationStore = usePortalCustomizationStore();
  hsaStore = useHsaStore();
  expenseBalanceSummaryStore = useExpenseBalanceSummaryStore();
  custodianSettingsStore = useCustodianSettingsStore();
  partnerPortalStore = usePartnerPortalStore();
  communicationStore = useCommunicationStore();
  driveWealthStore = useDrivewealthStore();
  featureFlagStore = useFeatureFlagStore();
  hsabAccountsStore = useHsabAccountsStore();
  devinirTransferInKindStore = useDevinirTransferInKindStore();

  RouteNames = RouteNames;
  storeType = StoreType;

  @Prop() forcePageReload: boolean;

  @Prop() routeToContributions: Location;

  created () {
    if (this.forcePageReload) {
      this.$router.go(0);
    }
  }

  mounted (): void {
    if (this.userStore.loggedIn) {
      this.expenseBalanceSummaryStore.loadState();
      this.partnerPortalStore.getPartnerPortalStatus();
      this.communicationStore.loadEmployeeCommunications({ planTypes: null, dashboard: CommunicationDashboard.Hsa });
      this.custodianSettingsStore.getCustodianSettings();
      this.hsaStore.loadTransactionTotals();
      this.userStore.loadPartnerSettings();
      this.deductibleTrackerStore.loadTalonEnabledForUser();
      this.portalCustomizationStore.getHsaStoreInfo(this.portalCustomizationStore.partnerId);

      if (this.devenirNonCompliantUserMessageEnabled && this.custodianSettingsStore.isHsaBankCustodian) {
        this.driveWealthStore.loadAccountSummariesV2({});
        this.driveWealthStore.loadAccountClaims({});
        this.nonCompliantInvestmentAccountRedirect();
      }
    }
  }

  get showMfa () {
    // when this flag is on, MFA prompt is handled via the LoginPromptOrchestator in the navbar
    return !this.featureFlagStore.flags.bend26540LoginPromptOrchestrator;
  }

  get displayCommunicationTiles (): boolean {
    return this.partnerPortalStore.hasActiveAccount &&
        this.communicationStore.hasCommunications;
  }

  get devenirNonCompliantUserMessageEnabled (): boolean {
    return this.featureFlagStore.flags.bend22211DevenirNonCompliantUserMessageDisplay;
  }

  @Watch("hsabAccountsStore.accountsFetchState")
  notionalAccountsRedirect () {
    if (this.hsabAccountsStore.notionalAccounts.length > 0) {
      this.$router.push({ name: RouteNames.AccountsSummary });
    }
  }

  @Watch("devinirTransferInKindStore.hasNonCompliantDevinirInvestmentAccounts")
  nonCompliantInvestmentAccountRedirect () {
    if (this.devenirNonCompliantUserMessageEnabled
      && this.devinirTransferInKindStore.hasNonCompliantDevinirInvestmentAccounts
      && !this.devinirTransferInKindStore.nonCompliantMessageAcknowledged) {
      this.$router.push({
        name: RouteNames.DevinirNonCompliantAccountsLandingPage,
        params: { accountId: `${this.devinirTransferInKindStore.nonCompliantDevinirInvestmentAccountId}` },
      });
    }
  }

  get hsaAccountIsNotReady (): boolean {
    return this.partnerPortalStore.isPortalStatusLoaded && !this.partnerPortalStore.hasPortalAccess;
  }

  get isHPHC () {
    return this.portalCustomizationStore.partnerId === 11;
  }

  get customizationStoreType () {
    return StoreType[this.portalCustomizationStore.hsaStoreInfo.storeType];
  }

  handleActionLinkClick (v: any) {
    const r: any = this.communicationStore.communications.filter(x => x.id === v)[0];
    if (r.isActionLinkExternal) {
      openUrl(r.actionLink);
    } else {
      this.$router.push(getRoutePath(r.actionLink));
    }

    this.userStore.saveUserEvent({
      eventType: UserEventType.PartnerCommunicationWidgetClick,
      values: [
        { key: UserEventKey.PartnerCommunicationId, value: r.id },
        { key: UserEventKey.PartnerCommunicationSubject, value: r.subject },
        { key: UserEventKey.PartnerCommunicationLocation, value: "employee" }
      ]
    });
  }
}
